// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__zGmC9","header":"sidebar_header__CBpNs","tuneIcon":"sidebar_tuneIcon__uE9ZJ","wrapper":"sidebar_wrapper__9Ovoc"};